interface Props {
  [key: string]: any
}
function LocationPinThinIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 18 20" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M14.539 14.5443L10.3244 18.7589C10.1401 18.9434 9.92119 19.0898 9.68028 19.1896C9.43937 19.2895 9.18113 19.3409 8.92034 19.3409C8.65955 19.3409 8.40132 19.2895 8.1604 19.1896C7.91949 19.0898 7.70062 18.9434 7.5163 18.7589L3.30071 14.5443C2.18942 13.433 1.43263 12.017 1.12605 10.4756C0.819469 8.93413 0.976859 7.33639 1.57832 5.88439C2.17978 4.43239 3.1983 3.19134 4.50508 2.31819C5.81185 1.44504 7.3482 0.979004 8.91985 0.979004C10.4915 0.979004 12.0278 1.44504 13.3346 2.31819C14.6414 3.19134 15.6599 4.43239 16.2614 5.88439C16.8628 7.33639 17.0202 8.93413 16.7136 10.4756C16.4071 12.017 15.6503 13.433 14.539 14.5443V14.5443Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M11.8998 8.92548C11.8998 9.7158 11.5858 10.4738 11.027 11.0326C10.4681 11.5914 9.71018 11.9054 8.91986 11.9054C8.12954 11.9054 7.37158 11.5914 6.81274 11.0326C6.2539 10.4738 5.93994 9.7158 5.93994 8.92548C5.93994 8.13515 6.2539 7.3772 6.81274 6.81835C7.37158 6.25951 8.12954 5.94556 8.91986 5.94556C9.71018 5.94556 10.4681 6.25951 11.027 6.81835C11.5858 7.3772 11.8998 8.13515 11.8998 8.92548V8.92548Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.98661"
      />
    </svg>
  )
}

export default LocationPinThinIcon
